import { createSelector } from "@reduxjs/toolkit";


const getDefaultQuerySearch = (defaults) => {
  const result = {};

  const sort = defaults?.sort?.find( (item) => item.default === true);
  if(sort) {
    result.sort = [{field: sort.value, type: sort.type}];
  }

  const filter = defaults?.filter?.find( (item) => item.default === true);
  if(filter) {
    result.filter = [{field: filter.value, op: filter.op}];
  }
  
  if(!result.sort && !result.filter) {
    return null;
  }
  
  return result;
};

const getManagerSearch = createSelector(
  [
    (state) => state.manager,
     (_, type) => type,
     (_, __, defaults) => defaults
  ],
  (pages, type, defaults) => {
    
    const search = pages[type];
    
    if(!search || Object.keys(search).length === 0) {
      return getDefaultQuerySearch(defaults);
    }

    const sort = [];
    if(search.sort) {
      sort.push(search.sort);
    }
    
    const result = {};
    if(sort.length) {
      result.sort = sort
    }

    const filter = [];
    if(search.field) {
      const value = (search?.value ?? '').trim();

      if(value || (!value && search.disableEdit)) {
        
        filter.push({
          field: search.field,
          value: search?.value ?? '',
          op: 'contains'    
        });
        
        const item = defaults?.filter?.find( (item) => item.value === search.field);
        if(item && item.extra) {
          filter.push(...item.extra);
        }

      }
    }

    

    if(sort.length === 0 && filter.length === 0) {
      return null;
    }

    
    if(filter.length) {
      result.filter = filter;
    }

    return result;
  }
);



export {
  getManagerSearch,
  getDefaultQuerySearch
};